import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireSystemAdmin } from '~/utils/guards';

/**
 * Compare Syncs route (`/explorer/data-quality/compare`). Super-admin only;
 * lazy-loaded. Lets an operator diff per-product quality between two syncs.
 */
const DataQualityComparePage = lazy(
  () => import('~/features/explorer/pages/data-quality-compare-page'),
);

// `sc` seeds the subsidiary scope from the dashboard link / a deep link.
const searchSchema = z.object({
  sc: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_tenant/explorer/data-quality/compare')({
  validateSearch: searchSchema,
  beforeLoad: requireSystemAdmin(),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <DataQualityComparePage />
    </Suspense>
  );
}
